import React, { Component, lazy } from "react";
import Search from "./common/Search";
import { RouteComponentProps } from "react-router-dom";
import { Route } from "react-router-dom";

const Home = lazy(() => import("../component/Home"));
const Commodity = lazy(() => import("../component/Commodity"));
const CommodityDetail = lazy(() => import("./commodity/CommodityDetail"));
const ActiveList = lazy(() => import("../component/index/ActiveList"));

interface MainState {}

class Main extends Component<RouteComponentProps, MainState> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  render():
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | string
    | number
    | {}
    | React.ReactNodeArray
    | React.ReactPortal
    | boolean
    | null
    | undefined {
    return (
      <div>
        <Search
          history={this.props.history}
          location={this.props.location}
          match={this.props.match}
        />
        <Route exact path="/main" component={Home} />
        <Route exact path="/main/commodity" component={Commodity} />
        <Route
          exact
          path="/main/commodity/:id/detail"
          component={CommodityDetail}
        />
        <Route exact path="/main/active/:id/list" component={ActiveList} />
      </div>
    );
  }
}

export default Main;
